export const body = {
    padding: "10px",
    textAlign: "center",
    fontWeight: "bold",
    foneSize: "1.5rem"
};
